export function downloadXLSXFile(data: any, filename: string) {
    const link = window.document.createElement('a')
    // Browsers that support HTML5 download attribute
    link.href = window.URL.createObjectURL(new Blob([data]))
    if (link?.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        link.download = `${filename}.xlsx`
    }
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export function openPDFFile(data: any, filename: string) {
    const blob = new Blob([data], {type: 'application/pdf'})
    const link = window.document.createElement('a')
    // unfortunately not possible to open in tab and name the file
    // link.download = `${filename}.pdf`
    console.log('openPDFFile', filename)
    link.target = '_blank'
    link.href = window.URL.createObjectURL(blob)
    link.click();
}